
<script>
import { required } from "vuelidate/lib/validators";
import config from "../../config";
import { error_message } from "../../Helper/helper";
import { success_message } from "../../Helper/helper";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { pageService } from "../../services";

export default {
  components: {config,ckeditor: CKEditor.component,pageService},
  data() {
    return {
      config: config,
      editor: ClassicEditor,
      typeform: {
        page_name: "",
        page_title: "",
        page_content: "",
      },
    };
  },
  validations: {
    typeform: {
      page_name: {
        required,
      },
      page_title: {
        required,
      },
      page_content: {
        required,
      },
    },
  },
  methods: {
    addPage(e){
      this.$v.$touch();
      if (this.$v.typeform.$invalid) {
        return;
      }
      else{       
        pageService.addContentPage(this.typeform)
        .then(response => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            this.$router.push({ name: "content-list" });
          } else {
            error_message(response.data.message);
          }
        });
      }
    }
  },
};
</script>

<template>
    <form @submit.prevent="addPage">
        <div class="card">
            <div class="card-body">
                <p class="card-title-desc"></p>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Page Name') }}</label>
                            <input
                                id="page_name"
                                v-model="$v.typeform.page_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Page Name')"
                                name="page_name"
                                :class="{ 'is-invalid': $v.typeform.page_name.$error }"
                            />
                            <div v-if="$v.typeform.page_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.page_name.required">{{ trans.get('__JSON__.Please Enter Page Name') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Page Title') }}</label>
                            <input
                                id="page_title"
                                v-model="$v.typeform.page_title.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Page Title')"
                                name="page_title"
                                :class="{ 'is-invalid': $v.typeform.page_title.$error }"
                            />
                            <div v-if="$v.typeform.page_title.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.page_title.required">{{ trans.get('__JSON__.Please Enter Page Title') }}</span>
                            </div>
                        </div>
                    </div>       
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Page Content') }}</label>
                            <ckeditor
                                id="page_content"
                                v-model="$v.typeform.page_content.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Page Content')"
                                name="page_content"
                                :editor="editor"
                                :class="{ 'is-invalid': $v.typeform.page_content.$error }"
                            ></ckeditor>
                            <div v-if="$v.typeform.page_content.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.page_content.required">{{ trans.get('__JSON__.Please Enter Page Content') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Add Content Page') }}</button>
            <!-- <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button> -->
            <router-link
              :to="{name:'content-list'}"
            >
              <b-button 
                type="button" 
                variant="secondary" 
                class="mt-3">
                {{ trans.get('__JSON__.Cancel') }}
              </b-button>
            </router-link>
          </div>
        </div>
    </form>
</template>

